module.exports = __webpack_public_path__ + "img/talent.c26b0927.png";